var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMarkMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.364 15.3639L9 21.7279L2.636 15.3639C1.37734 14.1052 0.520187 12.5016 0.172928 10.7558C-0.17433 9.00994 0.00390685 7.20035 0.685099 5.55582C1.36629 3.91129 2.51984 2.50569 3.99988 1.51677C5.47992 0.527838 7.21998 0 9 0C10.78 0 12.5201 0.527838 14.0001 1.51677C15.4802 2.50569 16.6337 3.91129 17.3149 5.55582C17.9961 7.20035 18.1743 9.00994 17.8271 10.7558C17.4798 12.5016 16.6227 14.1052 15.364 15.3639ZM8 5H10V11H8V5ZM9 12C8.44771 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkMarker);
export default __webpack_public_path__ + "static/media/exclamation-mark-marker.7c86683d3c28f35f984b0fe0fcbde587.svg";
export { ForwardRef as ReactComponent };